import { queryClient } from './client.js';

export {
  getIncidentPhoneQueryOptions,
  getIncidentPhoneQueryKey,
  getIncidentCustomerOptionsQueryOptions,
} from './phone.js';
import {
  getContactListQueryKey as getGeneratedContactListQueryKey,
  getVerificationChallengesQueryKey,
} from './contacts.js';
import { getSessionQueryKey as getGeneratedSessionQueryKey } from './generated/identity/identity.js';

// Generated query factories own request validation, cancellation, and cache keys.
export {
  getWebhookQueryKey,
  getWebhookQueryOptions,
  getWebhooksQueryOptions,
  getWebhookProviderQueryOptions,
} from './webhooks.js';
export {
  getSessionQueryOptions,
  getSessionQueryKey,
  useSession,
} from './generated/identity/identity.js';
export {
  getGetUserQueryKey,
  getGetUserQueryOptions,
  getListMembershipsQueryKey,
  getListMembershipsQueryOptions,
  getListUsersQueryKey,
  getListUsersQueryOptions,
  getListSessionsQueryOptions,
} from './generated/access/access.js';
export { getAuthenticationEventsQueryOptions } from './generated/audit/audit.js';
export {
  getListCustomerManagementEventsQueryKey,
  getListCustomerManagementEventsQueryOptions,
} from './generated/audit/audit.js';
export { getDeleteCustomerMutationKey } from './generated/customers/customers.js';
export {
  getTeamQueryKey,
  getTeamQueryOptions,
  getTeamsQueryKey,
  getTeamsQueryOptions,
} from './teams.js';
export {
  getListTeamMembershipsQueryKey,
  getListTeamMembershipsQueryOptions,
} from './generated/teams/teams.js';
export {
  getContactListQueryKey,
  getContactListQueryOptions,
  getVerificationChallengesQueryOptions,
} from './contacts.js';
export {
  getCustomerAssignmentsQueryKey,
  getCustomerAssignmentsQueryOptions,
  getCustomerKnownNumbersQueryKey,
  getCustomerKnownNumbersQueryOptions,
  getCustomerQueryKey,
  getCustomerQueryOptions,
  getCustomersQueryKey,
  getCustomersQueryOptions,
} from './customers.js';

export {
  getIncidentQueryKey,
  getIncidentQueryOptions,
  getIncidentsQueryKey,
  getIncidentsQueryOptions,
  invalidateIncidentQueries,
} from './incidents.js';

export async function invalidateContactQueries(userId: string): Promise<void> {
  const contactListKey = getGeneratedContactListQueryKey(userId)[0];
  const verificationKey = getVerificationChallengesQueryKey(userId)[0];
  await queryClient.invalidateQueries({
    predicate: (query) =>
      query.queryKey[0] === contactListKey || query.queryKey[0] === verificationKey,
  });
}

export function evictPrivateQueries(): void {
  const sessionKey = getGeneratedSessionQueryKey()[0];
  queryClient.removeQueries({ predicate: (query) => query.queryKey[0] !== sessionKey });
}

export {
  getListNotificationPoliciesQueryKey,
  getListNotificationPoliciesQueryOptions,
  getListTeamNotificationPoliciesQueryKey,
  getListTeamNotificationPoliciesQueryOptions,
  getGetNotificationPolicyQueryKey,
  getGetNotificationPolicyQueryOptions,
  getListNotificationRecipientOptionsQueryKey,
  getListNotificationRecipientOptionsQueryOptions,
  getListIncidentNotificationResponsesQueryKey,
  getListIncidentNotificationResponsesQueryOptions,
} from './generated/notifications/notifications.js';
export { getTeamSchedulesQueryOptions, getScheduleQueryOptions } from './schedules.js';

export async function invalidateNotificationResponseQueries(): Promise<void> {
  await queryClient.invalidateQueries({
    predicate: (query) => {
      const path = query.queryKey[0];
      return typeof path === 'string' && path.endsWith('/notification-responses');
    },
  });
}

export {
  getPhoneSettingsQueryOptions,
  getTeamPhoneNumberQueryOptions,
} from './phoneConfiguration.js';
